import { types } from 'mobx-state-tree';

const AccountsBalance = types
  .model('AccountsBalance', {
    balance: types.maybe(types.string),
    currency: types.maybe(types.string),
    email: types.maybe(types.string),
    update_time: types.maybe(types.string),
  });

export default AccountsBalance;
